<template>
    <div ref="biChartRef" class="project-bi-chart">
        <div class="relative flex h-full w-full items-center justify-center">
            <span v-if="props.isLoading || !isChartLoaded"
                  class="th-loading th-loading-spinner th-loading-lg absolute left-1/2 top-1/2 block -translate-x-1/2 -translate-y-1/2 bg-grey-200"></span>
            <div :class="`${containerClass} w-full h-full`" v-show="!props.isLoading">
            </div>
        </div>
        <div class="chart-no-data h-full w-full flex-col items-center justify-center gap-1" style="display: none">
            <img src="@/assets/images/nodata-inline.png"  />
            <div>{{ t('report.chartNoData') }}</div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref, withDefaults } from 'vue';
import { useBIChart } from '@/composables/use-bi-chart';
import { useI18n } from 'vue-i18n';
import { useResizeObserver } from '@vueuse/core';

const { t } = useI18n()

const props = withDefaults(defineProps<{
    configTaskFunc: () => Promise<any>,
    dataTaskFunc: () => Promise<any>,
    colorFunc?: (data: any[]) => any[],
    chartKey: string,
    isLoading: boolean,
}>(), {
    isLoading: true,
});

const biChartRef = ref<HTMLDivElement>();

const emits = defineEmits(['click', 'chart-loaded']);

const { containerClass, getBase64Str, visualCurr, isChartLoaded } = useBIChart(props, emits);

useResizeObserver(biChartRef, (entries) => {
    visualCurr.value?.chart.resize?.()
})

defineExpose({
    getBase64Str,
    visualCurr,
});

</script>
